import React from "react";
import './card.styles.css';


export const Card = (props) =>(
  <div  className="card-container">
    <img src={`https://robohash.org/${props.puppy.id}?set=set4&size=180x180`} alt="Puppy" />
    <h2>{props.puppy.name}</h2>
    <p>{props.puppy.email}</p>
  </div>
)